<template>
  <div>
    <template
      v-for="(produto, index) in produtos"
    >
      <CardFotoProduto
        :key="`foto-${produto.id}`"
        :imagem="produto.image_url"
        :possui-card-superior="possuiCardSuperior || index > 0"
        :titulo="produto.name"
        :produtos="[produto]"
      />
      <v-card
        :key="produto.id"
        class="mb-5 pa-5"
      >
        <p
          v-if="$vuetify.breakpoint.smAndDown"
          class="primary--text"
        >
          {{ produto.name }}
        </p>

        <p class="mb-5 grey--text text--darken-2">
          Encontre aqui os arquivos disponibilizados pelo vendedor.
        </p>

        <v-card-actions class="flex-column pa-0">
          <BtnBaixarAquivos
            :downloads="produto.downloads"
            :venda-id="dadosTransacao.id"
          />
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import BtnBaixarAquivos from '@/components/Compras/BtnBaixarAquivos.vue';
import CardFotoProduto from '@/components/Compras/CardFotoProduto.vue';
import { mapState } from 'vuex';

export default {
  name: 'CardProdutoDownload',

  components: {
    BtnBaixarAquivos,
    CardFotoProduto,
  },

  props: {
    produtos: {
      type: Array,
      required: true,
    },
    possuiCardSuperior: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['dadosTransacao']),
  },
};
</script>
